if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this._initPriceSync();
    }

    _formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    _updateAtcPrice() {
      const priceEl = this.submitButton && this.submitButton.querySelector('.product-price-main');
      if (!priceEl || !priceEl.dataset.unitPrice) return;
      const unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
      if (isNaN(unitPrice)) return;
      let qtyInput = this.form.elements.namedItem('quantity');
      if (qtyInput && qtyInput.length) qtyInput = qtyInput[0];
      if (!qtyInput) qtyInput = this.form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      priceEl.textContent = this._formatMoney(unitPrice * qty);
    }

    _initPriceSync() {
      // Listen for quantity changes (covers both user edits and programmatic setFormQuantity calls)
      const onQtyChange = this._updateAtcPrice.bind(this);
      this.form.addEventListener('input', (e) => { if (e.target.name === 'quantity') onQtyChange(); });
      this.form.addEventListener('change', (e) => { if (e.target.name === 'quantity') onQtyChange(); });

      // For quantity inputs outside the form DOM but associated via form="..."
      const formId = this.form.id;
      if (formId) {
        document.addEventListener('input', (e) => {
          if (e.target.name === 'quantity' && e.target.getAttribute('form') === formId) onQtyChange();
        });
        document.addEventListener('change', (e) => {
          if (e.target.name === 'quantity' && e.target.getAttribute('form') === formId) onQtyChange();
        });
      }

      // Re-apply after variant change re-renders the button content
      const textEl = this.submitButton && this.submitButton.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        new MutationObserver(onQtyChange).observe(textEl, { childList: true });
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading--spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-add-to-cart-text]').classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.submitButton.setAttribute('disabled', true);
            this.error = true;
             const drawerSelector = document.querySelector("#quickView-drawer");
             setTimeout(() => {
              //focusElement = event.target;
              trapFocusElements(drawerSelector);
          }, 500);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if(this.cart){
            if(document.querySelector(".product-sticky-bar")){
              document.querySelector(".product-sticky-bar").classList.remove("is-visible")
            }
            this.cart.renderContents(response);
            this.cart.classList.add("is-visible");
            focusElement = this.submitButton;
            document.querySelector("body").classList.add("overflow-hidden");
          
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-add-to-cart-text]').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('disabled');
          this.querySelector('.loading--spinner')?.classList.add('hidden');
       
        });
    }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form--error-message-wrapper') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form--error-message') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}